// Angular
import {BrowserModule, Title} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ApplicationRef} from '@angular/core';

// Helpers components
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DateService} from '@services/date.service';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {SharedModule} from '@helpers/modules/shared.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {WindowEventsService} from '@services/window-events.service';
import {ProvidersModule} from '@providers/providers.module';
import {AppLayoutComponent} from './layouts/app-layout/app-layout.component';
import {AuthLayoutComponent} from './layouts/auth-layout/auth-layout.component';
import {AuthService} from '@services/auth.service';
import {AuthGuardService} from '@services/guards/auth-guard.service';
import {NotAuthGuardService} from '@services/guards/not-auth-guard.service';
import {HttpAuthInterceptor} from './classes/http-auth-interceptor';
import {GlobalErrorHandler} from './classes/global-error-handler';
import {ErrorPageComponent} from './pages/error-page/error-page.component';
import {ErrorsStackService} from '@services/errors-stack.service';
import {OnlyIfErrorsService} from '@services/guards/only-if-errors.service';
import {ErrorLoggerService} from '@services/error-logger.service';
import {EventsService} from '@services/events.service';
import {ApparatusModule} from './pages/apparatus/apparatus.module';
import {SpecialistPageModule} from './pages/specialist/specialist-page.module';
import {PackagesModule} from './pages/packages/packages.module';
import {OrganizationModule} from './pages/organization/organization.module';
import {RegistrationModule} from './pages/registration/registration.module';
import {ProfileModule} from './pages/profile/profile.module';
import {NotFoundModule} from './pages/not-found/not-found.module';
import {RouterModule} from '@angular/router';
import {NotyComponent} from '@components/noty/noty.component';
import {UrlManagerService} from '@services/url-manager.service';
import {PagePreloaderComponent} from '@components/page-preloader/page-preloader.component';
import {CheckPermissionsGuardService} from '@services/guards/check-permissions.guard.service';
import {ApiModule} from '@api/api.module';
import {DataEventsService} from '@services/data-events.service';
import {ConfirmComponent} from '@components/confirm/confirm.component';
import {UpdateCallerComponent} from '@components/update-caller/update-caller.component';
import {ApplicationConfigService} from '@services/application-config.service';
import {ForbiddenPageComponent} from './pages/forbidden-page/forbidden-page.component';
import {WorkingObjectsModule} from './pages/working-objects/working-objects.module';
import {PreviewModalComponent} from '@components/preview-modal/preview-modal.component';
import {PreviewModalService} from '@services/preview-modal.service';
import {AjaxDownloadNotyModule} from '@components/ajax-download-noty/ajax-download-noty.module';
import {Lab365CommonModule} from '@lab365/common';
import {IconsModule} from '@lab365/icons';

@NgModule({
    declarations: [
        // Components
        AppComponent,

        AppLayoutComponent,
        AuthLayoutComponent,
        ErrorPageComponent,
        ForbiddenPageComponent,

        NotyComponent,
        ConfirmComponent,
        PagePreloaderComponent,
        UpdateCallerComponent,
        PreviewModalComponent,
    ],
    imports: [
        // Angular
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule,

        // Custom modules
        ProvidersModule,
        SharedModule,
        DirectivesModule,
        ApiModule,
        AjaxDownloadNotyModule,
        Lab365CommonModule,

        AppRoutingModule,
        ApparatusModule,
        SpecialistPageModule,
        PackagesModule,
        OrganizationModule,
        RegistrationModule,
        ProfileModule,
        NotFoundModule,
        WorkingObjectsModule,
        IconsModule,
    ],
    providers: [
        DateService,
        Title,
        WindowEventsService,
        EventsService,
        ApplicationConfigService,
        DataEventsService,
        PreviewModalService,


        AuthService,
        AuthGuardService,
        NotAuthGuardService,
        OnlyIfErrorsService,
        CheckPermissionsGuardService,
        UrlManagerService,

        ErrorsStackService,
        ErrorLoggerService,

        /**
         * Перехватчик запросов для внедрения токена авторизации и других параметров заголовков
         */
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpAuthInterceptor,
            multi: true
        },

        /**
         * Гловабльный перехватчик ошибок Runtime
         */
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        }
    ],
    entryComponents: [
        AppComponent,
    ]
})
export class AppModule {
    ngDoBootstrap(appRef: ApplicationRef) {
        if (document.getElementsByTagName('app-root').length) {
            appRef.bootstrap(AppComponent);
        }
    }
}
